import { Component, computed, inject, signal } from "@angular/core";
import { FeedbackPromptService } from "src/app/features/services/utils/feedback-prompt-service";
import { Button } from "../button/button";
import { Router } from "@angular/router";
import { Icon } from "../icon/icon";
import { CdkDrag } from "@angular/cdk/drag-drop";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "feedback-prompt",
  imports: [Button, Icon, CdkDrag, TranslocoModule],
  templateUrl: "./feedback-prompt.html",
})
export class FeedbackPrompt {
  private readonly prompt = inject(FeedbackPromptService);
  private readonly router = inject(Router);
  rating = signal<number>(0);
  maxRating = signal<number>(5);
  ratingButtons = computed(() =>
    Array.from({ length: this.maxRating() }, (_, i) => i + 1)
  );
  setRating(rating: number): void {
    this.rating.set(rating);
  }

  readonly isOpen = this.prompt.isOpen;

  close(): void {
    this.prompt.close();
  }

  redirectToFeedback(): void {
    this.router.navigateByUrl("/user-profile/feedback", {
      state: { rating: this.rating() },
    });
    this.close();
  }
}
